var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationAlertOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-info"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 901",
    d: "M33 18A15 15 0 1 1 18 3a15 15 0 0 1 15 15z",
    style: {
      fill: "none",
      stroke: "#ff9300",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    transform: "translate(-1.5 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 902",
    d: "M18 24v-6",
    style: {
      fill: "none",
      stroke: "#ff9300",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    transform: "translate(-1.5 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 903",
    d: "M18 12h0",
    style: {
      fill: "none",
      stroke: "#ff9300",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    transform: "translate(-1.5 -1.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlertOrange);
export default __webpack_public_path__ + "static/media/NotificationAlertOrange.249c88ba5fb904b04da55659d44b9b07.svg";
export { ForwardRef as ReactComponent };